import { SearchCriteriaType } from '../types/oneGraphTypes';

const filterAvailableFilters = (availableFilters: SearchCriteriaType[]) => {
  const listOfFiltersNeeded = [
    'has-warranties',
    'available-from-code',
    'order-status',
    'sale-order-type',
    'body-type',
    'model-range',
    'trimline',
    'exterior-color',
    'interior-color-seats',
    'vtp-drivetrain',
    'fuel',
    'drive',
    'wheel-size',
    'gear-type',
    'sales-model-year',
    'stat-import',
    'powerKw-fr',
    'powerKw-to',
    'prices.retail-fr',
    'prices.retail-to',
    't_manuf',
    't_model',
    'foreign-brand',
  ];
  const filteredAvailableFilters = availableFilters.filter((toCheck) =>
    listOfFiltersNeeded.includes(toCheck.id),
  );
  return filteredAvailableFilters;
};

export default filterAvailableFilters;
